import React from 'react';
import { Layout } from 'antd';
import '../styles/Footer.css';

const { Footer } = Layout;

const AppFooter = () => {
  return (
    <Footer className="footer">
      <div>© 2024 PROBONO. All rights reserved.</div>
    </Footer>
  );
};

export default AppFooter;
